module.exports = __webpack_public_path__ + "static/media/placed.0efd39bf.png";